import { QueryErrorResetBoundary } from "@tanstack/react-query";
import { ErrorBoundary } from "react-error-boundary";
import { Button } from "_c/Button";
import type { CSSProperties } from "react";

const QueryErrorBoundary: React.FC<{
  children: any;
  errorStyle?: CSSProperties;
}> = (props) => (
  <QueryErrorResetBoundary>
    {({ reset }) => (
      <ErrorBoundary
        onReset={reset}
        fallbackRender={({ resetErrorBoundary, error }) => (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "1rem",
              ...props.errorStyle,
            }}
          >
            <span>
              {error instanceof Error ? error.message : String(error)}
            </span>
            <Button onClick={() => resetErrorBoundary()}>Try again</Button>
          </div>
        )}
      >
        {props.children}
      </ErrorBoundary>
    )}
  </QueryErrorResetBoundary>
);

export default QueryErrorBoundary;
